import React, { useState } from "react";
import ModalBox from "../../../components/modal/ModalBox";
import { Button } from "../../../components/Button/Button";
import { cashConverter } from "../../../components/Form";
import {
  catchMessage,
  elseMessage,
  successMessage,
} from "../../../comman/Message";
import { fundRequestActionApi } from "../../../services/theFunds";

const RequestedModal = ({ show, close, id, fundDetail, listing }) => {
  const [declineRequestModal, setDeclineRequestModal] = useState(false);
  const [paidRequestModal, setPaidRequestModal] = useState(false);
  const [value, setValue] = useState("");

  // console.log('fundDetail', fundDetail)
  //--------decline-Request-modal-------------
  const declineRequest = () => {
    setDeclineRequestModal(true);
    setValue("declineRequest");
  };
  //--------paid-To-Resource-modal-------------
  const paidToResource = () => {
    setPaidRequestModal(true);
    setValue("paidResource");
  };
  //----------decline-request----Paid-to-resource---------------
  const fundRequest = async () => {
    try {
      // const data = {aidId: id, status: value === 'declineRequest' ? false : true }
      const data = {
        aidId: id,
        status: value === "declineRequest" ? "reject" : "accept",
      };
      const res = await fundRequestActionApi(data);
      if (res?.data?.status === 200) {
        if (value === "declineRequest") {
          setDeclineRequestModal(false);
          close();
        } else {
          setPaidRequestModal(false);
          close();
        }
        successMessage(res);
        listing();
      } else {
        elseMessage(res);
      }
    } catch (err) {
      catchMessage(err);
    }
  };
  return (
    <>
      <ModalBox
        status={show}
        onClose={close}
        // title={"Requested Details"}
        custom
        size="md"
        customizedFooter={
          <button className="btn_size" onClick={close}>
            Close
          </button>
        }
      >
        {/* <hr /> */}
        <div className="row ">
          <div className="col-6">
            <h4>Funds Request</h4>
          </div>
          <div className="col-6 d-flex justify-content-end">
            <Button className="mx-3" onClick={declineRequest}>
              Decline request
            </Button>
            <Button onClick={paidToResource}>Approve Request</Button>
          </div>
        </div>
        <div className="customer_details">
          <div className="innner">
            <div className="row">
              <div className="col-6">
                <ul>
                <li>
                    <strong>Full Name</strong>
                    <span>: {fundDetail?.name || "N/A"}</span>
                  </li>
                  <li>
                    <strong>Username</strong>
                    <span>: {fundDetail?.userName || "N/A"}</span>
                  </li>
                  <li>
                    <strong>Email address</strong>
                    <span>: {fundDetail?.email || "N/A"}</span>
                  </li>
                  <li>
                    <strong>Fund requested</strong>
                    <span>: {cashConverter(fundDetail?.amount) || "N/A"}</span>
                  </li>

                  <li>
                    <strong>Need</strong>
                    <span>: {fundDetail?.need || "N/A"}</span>
                  </li>

                  <li>
                    <strong> Current Income
                    </strong>
                    <span>: {fundDetail?.currentIncome || "N/A"}</span>
                  </li>
                  <li>
                    <strong>Current Challenges
                    </strong>
                    <span>: {fundDetail?.currentChallenges || "N/A"}</span>
                  </li>
                </ul>
              </div>
              <div className="col-6">
                <ul>

                  <li>
                    <strong>Financial Situation</strong>
                    <span>                   : {fundDetail?.financialSituation || "N/A"}</span>
                  </li>
                  <li>
                    <strong>Goals and Aspirations</strong>
                    <span>                     : {fundDetail?.goals || "N/A"}</span>
                  </li>
                  <li>
                    <strong>Expected Benefits</strong>
                    <span>: {fundDetail?.expectedBenefits || "N/A"}</span>
                  </li>
                  <li>
                    <strong>Your Story</strong>
                    <span>: {fundDetail?.story || "N/A"}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </ModalBox>
      {/* --------Decline-Request--------- */}
      <ModalBox
        status={declineRequestModal}
        onClose={() => setDeclineRequestModal(false)}
        title="Decline Request"
        description="Are you sure you want to decline this request?"
        action={fundRequest}
      />
      {/* --------Paid-Resource--------- */}
      <ModalBox
        status={paidRequestModal}
        onClose={() => setPaidRequestModal(false)}
        title="Approve Request"
        description="Are you sure you want to approve this request?"
        action={fundRequest}
      />
    </>
  );
};

export default RequestedModal;
